<script lang="ts" setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emits = defineEmits<{
  (e: "on-close"): void;
  (event: "confirm"): void;
}>();

const handleCloseModal = () => {
  emits("on-close");
};

const isLoading = ref(false);
</script>

<template>
  <div class="bg-black fixed inset-0 z-50 flex items-center justify-center text-white">
    <div class="flex flex-col items-center gap-4 p-6 text-center">
      <img src="/images/verify-email.svg" class="w-10 md:w-20 mx-auto mb-3" alt="Fungiball Logo" />
      <div class="md:text-3xl text-2xl">{{ t("_auth.v2-to-v1-redirect.title") }}</div>
      <div>
        <p class="text-center max-w-4xl text-sm md:text-base text-gray-400">
          {{ t("_auth.v2-to-v1-redirect.description") }}
        </p>

        <div class="flex flex-col items-center">
          <Button
            @click="handleCloseModal"
            :loading="isLoading"
            size="sm"
            type="primary-blue"
            class="w-fit mt-6"
          >
            {{ t("_shared.close") }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
